<template>
  <v-layout align-center column>
    <p class="Text-Hero">
      Raih Keuntungan Hingga 20% dengan Pendanaan di Dompet Kilat
    </p>
    <div class="Google-Play">
      <v-img
        class="Shape2GPlayImage"
        max-width="268px"
        contain
        src="../../assets/homepage/LOGO DOWNLOAD-04.png"
        @click="note = true"
      />
    </div>
    <v-dialog
      transition="dialog-bottom-transition"
      v-model="note"
      max-width="600"
    >
      <v-card>
        <v-card-title class="white--text text-body-1 popupTitle">
          Download Aplikasi Dompetkilat
        </v-card-title>
        <v-card-text>
          <div class="text-body-1 black--text px-2 mt-6">
            Anda akan mengunduh aplikasi DompetKilat, Pastikan anda
            <span class="red--text font-weight-bold"
              >sudah memiliki kode akses</span
            >
          </div>
          <div class="text-body-1 px-2 mt-6">
            Masukkan kode akses untuk melanjutkan
            <v-text-field
              class="mt-2"
              v-model="noteCode"
              label="Kode Akses"
              color="#D3352C"
              outlined
              dense
              required
            ></v-text-field>
            <strong
              v-if="noteError"
              class="text-body-2 red--text text--lighten-1"
              >Kode Akses Salah !!</strong
            >
          </div>
        </v-card-text>
        <v-divider class="mx-4" />
        <v-card-actions class="justify-end">
          <div class="pb-2">
            <v-btn
              class="white--text text-none"
              color="#D3352C"
              min-width="125"
              rounded
              @click="closeNote"
              >Batal</v-btn
            >
            <v-btn
              class="ml-4 text-none"
              min-width="125"
              outlined
              color="black"
              rounded
              @click="toDownload"
              >Selanjutnya</v-btn
            >
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <img
      src="../../assets/Pendanaan-Mobile/Hero.png"
      srcset="
        ../../assets/Pendanaan-Mobile/Hero@2x.png 2x,
        ../../assets/Pendanaan-Mobile/Hero@3x.png 3x
      "
      class="Hero"
    />
    <keuntungan-mobile />
    <kategori-mobile />
    <cara-kerja-mobile />
    <pertanyaan-mobile />
  </v-layout>
</template>
<script>
import axios from "axios";
import CaraKerjaMobile from "../../components/pendanaan/CaraKerjaMobile.vue";
import KategoriMobile from "../../components/pendanaan/KategoriMobile.vue";
import KeuntunganMobile from "../../components/pendanaan/KeuntunganMobile.vue";
import PertanyaanMobile from "../../components/pendanaan/PertanyaanMobile.vue";
export default {
  components: {
    CaraKerjaMobile,
    PertanyaanMobile,
    KategoriMobile,
    KeuntunganMobile,
  },

  data() {
    return {
      note: false,
      noteError: false,
      noteCode: "",
    };
  },

  methods: {
    forceFileDownload(response, title) {
      console.log(title);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", title);
      document.body.appendChild(link);
      link.click();
    },
    download(url, title) {
      axios({
        method: "get",
        url,
        responseType: "arraybuffer",
      })
        .then((response) => {
          this.forceFileDownload(response, title);
        })
        .catch((err) => this.rollbar.debug(err));
    },
    toDownload() {
      if (this.noteCode === process.env.VUE_APP_DOWNLOAD_PASSWORD) {
        this.download(
          "https://ws-dk.dompetkilat.co.id/api/download",
          "DompetKilat_v3.0.apk"
        );
        this.noteCode = "";
        this.note = false;
        this.noteError = false;
      } else {
        this.noteError = true;
      }
    },
    closeNote() {
      this.note = false;
      this.noteCode = "";
      this.noteError = false;
    },
  },
};
</script>
<style scoped>
html,
body {
  width: 100%;
  overflow-x: hidden;
}
.Hero {
  width: 105%;
  /* height: 498px; */
  margin: -350px 0 -200px;
  padding: 0 0 230px;
  object-fit: contain;
}
.Text-Hero {
  width: 328px;
  height: 90px;
  flex-grow: 0;
  margin: 30px 0 36px;
  font-family: Sora;
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: -0.48px;
  text-align: center;
  color: #252525;
}
.Google-Play {
  z-index: 1;
  padding-top: 160px;
  padding-bottom: 60px;
}
</style>
